module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO43IngresosMenoresAGastos.51891ad.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO43IngresosMenoresAGastos.mp4
// module id = 769
// module chunks = 1